module.exports = __webpack_public_path__ + "img/access_4_ja.992a0c46.jpg";